import { Actions, ErrorText, Panel } from "../ui.js";

export interface DeletionRequestInfo {
  participantCode: string;
  /** Contacto del equipo configurado en el estudio. */
  contactInfo: string;
}

/**
 * La eliminación de datos se solicita al equipo investigador (no es autoservicio): se muestra el
 * código anónimo de la sesión y el contacto. El equipo borra la sesión desde el panel.
 */
function DeletionRequestBlock({ info }: { info: DeletionRequestInfo }) {
  return (
    <div className="space-y-3">
      <dl className="rounded-md bg-slate-50 p-4">
        <dt className="text-sm text-slate-500">Tu código de participante</dt>
        <dd className="font-mono text-2xl tracking-wide" data-testid="participant-code">
          {info.participantCode}
        </dd>
      </dl>
      <div className="text-sm" data-testid="deletion-request-info">
        <p>
          Si más adelante quieres que <strong>eliminemos tus datos</strong>, comunícate con el equipo del estudio e indica este
          código. Anótalo o tómale una foto: no está ligado a tu nombre y es la única forma de identificar tu sesión.
        </p>
        <p className="mt-2">
          <span className="font-semibold">Contacto:</span> {info.contactInfo}
        </p>
      </div>
    </div>
  );
}

export function CompleteScreen({
  finalizing,
  saveProblem,
  info,
  onRetrySave,
  onFinishAnyway,
}: {
  finalizing: boolean;
  saveProblem: number;
  info: DeletionRequestInfo | null;
  onRetrySave: () => void;
  onFinishAnyway: () => void;
}) {
  if (saveProblem > 0) {
    return (
      <Panel title="Guardando resultados">
        <ErrorText>
          No se pudieron guardar {saveProblem} {saveProblem === 1 ? "ensayo" : "ensayos"} por problemas de conexión.
        </ErrorText>
        <Actions>
          <button type="button" className="btn-primary" onClick={onRetrySave} data-testid="complete-retry">
            Reintentar
          </button>
          <button type="button" className="btn-secondary" onClick={onFinishAnyway}>
            Finalizar sin esos datos
          </button>
        </Actions>
      </Panel>
    );
  }
  if (finalizing) {
    return (
      <Panel title="Guardando resultados">
        <p role="status">Un momento, estamos terminando de guardar…</p>
      </Panel>
    );
  }
  return (
    <Panel title="¡Gracias por participar!" wide>
      <p data-testid="complete-message">La sesión terminó y la cámara está desactivada.</p>
      {info && <DeletionRequestBlock info={info} />}
    </Panel>
  );
}

export function AbortedScreen({ message, info }: { message: string; info: DeletionRequestInfo | null }) {
  return (
    <Panel title="Participación finalizada">
      <p data-testid="aborted-message">{message}</p>
      <p className="text-sm text-slate-500">La cámara está desactivada.</p>
      {info && <DeletionRequestBlock info={info} />}
    </Panel>
  );
}
